export const enhanceCodeBlocks = (htmlContent: string): string => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlContent;

  const codeBlocks = tempDiv.querySelectorAll('pre code');

  codeBlocks.forEach((codeElement) => {
    const preElement = codeElement.parentElement as HTMLElement | null;
    if (!preElement) return;

    // Avoid double-wrapping if already inside .codebox
    if (preElement.parentElement?.classList.contains('codebox')) {
      return;
    }

    // Get raw code and preserve all whitespace
    const rawCode = codeElement.textContent || '';

    // Build wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'codebox';

    // Header with title + copy button
    const header = document.createElement('div');
    header.className = 'codebox-header';

    const title = document.createElement('span');
    title.className = 'codebox-title';
    title.textContent = 'CODE';

    const copyBtn = document.createElement('button');
    copyBtn.className = 'codebox-copy';
    copyBtn.type = 'button';
    copyBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg><span>Copy</span>';
    
    // Store raw code in data attribute to preserve all spacing
    copyBtn.setAttribute('data-code', rawCode);
    copyBtn.setAttribute(
      'onclick',
      `navigator.clipboard.writeText(this.getAttribute('data-code')||'').then(()=>{this.innerHTML='<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg><span>Copied!</span>'; setTimeout(()=>{this.innerHTML='<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2 2v1"></path></svg><span>Copy</span>';}, 1500)})`
    );

    header.appendChild(title);
    header.appendChild(copyBtn);

    // Insert wrapper and move existing pre into it
    if (preElement.parentNode) {
      preElement.parentNode.insertBefore(wrapper, preElement);
      wrapper.appendChild(header);
      wrapper.appendChild(preElement);
    }

    // Preserve whitespace formatting
    codeElement.setAttribute('style', 'white-space: pre; tab-size: 2;');
    preElement.setAttribute('role', 'region');
    preElement.setAttribute('aria-label', 'code snippet');
  });

  return tempDiv.innerHTML;
};
